export const cdekAnalyticsNoscript = `
  <div><img src="https://mc.yandex.ru/watch/102963036" style="position:absolute; left:-9999px;" alt="" /></div>
`
